import type { UpdateRoleInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type { PaginatedRoles, RoleAdminRow, RolesAdminParams } from '../model/role-admin'

export async function getRolesAdmin(params: RolesAdminParams): Promise<PaginatedRoles> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedRoles>(`${API.roles.root}${qs ? `?${qs}` : ''}`)
  return data
}

/**
 * Mutaciones del PANEL (toggle activo, eliminar). El alta/edición completa
 * vive en la página create-update-role, que postea el payload rico
 * (permisos + matriz por estado + usuarios) por su cuenta.
 */
export async function updateRole(id: string, payload: UpdateRoleInput): Promise<RoleAdminRow> {
  const { data } = await axiosPrivate.patch<RoleAdminRow>(API.roles.byId(id), payload)
  return data
}

export async function deleteRole(id: string) {
  const { data } = await axiosPrivate.delete(API.roles.byId(id))
  return data
}
